import { useEffect } from "react";
import DataUserLoyalty from "../store/DataUserLoyalty";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

const Menu = observer(() => {
    const navigation = useNavigate();
    useEffect(() => {
        if (
            localStorage.getItem("user") == "undefined" ||
            localStorage.getItem("user") == null
        ) {
            navigation(
                `/userLoyalty/registration${
                    DataUserLoyalty.placeId
                        ? `?place_id=${DataUserLoyalty.placeId}`
                        : ""
                }`
            );
        }
    }, []);
    return <div>Menu</div>;
});

export default Menu;
